import { useEffect } from "react";
import { useCart } from "../hooks/apis/cart";
import { useCartStore } from "../store/useCartStore";

const CartWrapper = ({}) => {
  const { setCart, setShopping } = useCartStore((state) => state);
  const { data } = useCart();


  useEffect(() => {
    if (data) {
      setCart(data.products);
      setShopping(data.shopping_cart);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return <></>;
};

export default CartWrapper;
